module.exports = __webpack_public_path__ + "static/media/downloadwhite.33eb016f.svg";